import { ModalWrapper } from 'app/components/modal-wrapper/modal-wrapper';
import { toastFactory } from 'app/infrastructure/notifications/toast-factory';
import * as React from 'react';
import { ReactNode, useState, useCallback } from 'react';
import { toast } from 'react-toastify';
import { FileSelector } from 'ui/file-selector';

interface UploadDocumentProps {
  onClose: () => void;
  onSubmit: (file: File) => void;
  acceptFileType?: string;
  className?: string;
  maxSizeMB?: number;
  textCancel: string;
  textSubmit: string;
  textChooseFile: string;
  textTitle: string;
  textFileTooLargeError: string;
  children?: ReactNode;
}

export const UploadDocument = ({
  onClose,
  onSubmit,
  acceptFileType: acceptFileTypes = '',
  className,
  children,
  maxSizeMB = 100,
  textSubmit,
  textCancel,
  textChooseFile,
  textTitle,
  textFileTooLargeError
}: UploadDocumentProps) => {

  const [file, setFile] = useState(undefined as File);

  const onDone = useCallback(() => {
    if (file) {
      onSubmit(file);
    }
  }, [file, onSubmit]);

  const handleSelect = useCallback((selectedFile: File) => {
    setFile(selectedFile);
  }, [setFile]);

  const onError = useCallback(() => {
    toastFactory().dispatch(textFileTooLargeError, toast.TYPE.ERROR);
  }, [textFileTooLargeError]);

  return <ModalWrapper
    headerTitle={textTitle}
    btnTitle={textSubmit}
    btnCancelTitle={textCancel}
    onClose={onClose}
    onDone={onDone}
  >
    <div className={`input-wrapper ${className}`}>
      <FileSelector
        textSelectFile={textChooseFile}
        onSelected={handleSelect}
        disabled={false}
        acceptFileTypes={acceptFileTypes}
        maxSizeMB={maxSizeMB}
        textFileSizeError={textFileTooLargeError}
        onError={onError}
      />
      {children}
    </div>
  </ModalWrapper>;
};
